import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "./Layout.css";

export default function DashboardLayout() {
  return (
    <div className="dashboard" data-layout="dashboard">
      {/* Persistent sidebar on every page */}
      <Sidebar />

      {/* Right side: navbar + page content */}
      <div className="content-area">
        <Navbar />
        <main className="main" data-layout="main">
          <div className="container-fluid" data-layout="container">
            {/* Child route content (Dashboard, Values, etc.) renders here */}
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
